import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import LoadingIndication from '../../common/loading-indicator';

import ReferenceBox from '../../common/reference-box';
import Button from '../../common/button/button';
import articleTagsService from '../../../services/article-tags/article-tags';

import './articles-section.css';

export default class ArticlesSection extends Component {
  render() {
    let extraJSX;

    const { articles } = this.props;

    if (!articles) {
      extraJSX = (
        <LoadingIndication />
      );
    }
    else {
      if (articles.length === 0) {
        extraJSX = (
          <div>
            <p>There are no articles</p>
          </div>
        );
      }
      else {
        extraJSX = (
          <div className='articles-container'>
            <div className='articles'>
              {
                articles.map((article, i) => 
                  <div key={ `articles-${i}` } className='little-grow-animation'>
                    <ArticleBox { ...article } />
                  </div>
                )
              }
            </div>

            <Link to='/articles' title='Articles'>
              <Button
                label='Read More'
                isDark={ this.props.className !== 'dark' } />
            </Link>
          </div>
        );
      }
    }

    return (
      <section className={ `${ this.props.className } section-container articles-section-container` }>
        <h3 className='section-title'>
          My Articles
        </h3>

        { extraJSX }
      </section>
    );
  }

  // primary={true} 
  //         buttonStyle={readMoreButtonStyles.button} 
  //         labelStyle={readMoreButtonStyles.label} 
}

function ArticleBox(props) { 
  const { tags, linkId, _id } = props;

  const relevantTags = articleTagsService.getRelevantRecommendationsTags(tags);
  const imgSrc = `/images/articles/${ _id }/summary.png`;
  const link = `/articles/${ linkId }`;

  return (
    <div className='article-box little-grow-animation'>
      <ReferenceBox 
        { ...props }
        link={ link }
        imgSrc={ imgSrc }
        tags={ relevantTags } />
    </div>
  );
}